import BaseAPI from './base.api.service'

const resource = 'Lodges';
export default {
    async get(erID) {
        return await BaseAPI.get(`expensereports/${erID}/Lodges`);
    },
    async save(request) {
        return await BaseAPI.put(`${resource}/`, request)
    },
    async getLodgeSummary(erID) {
        return await BaseAPI.get(`expensereports/${erID}/Lodges/LocationSummary`);
    },
    async delete(id) {
        return await BaseAPI.delete(`${resource}/${id}`)
    }
} 